<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

  <div class="p-0.5">
    <p-toolbar>
      <ng-template #start>
          <p-selectButton [options]="tablePlot" [ngModel]="tablePlotSelected()"
            (onChange)="tablePlotToggle($event)" [allowEmpty]="false" appendTo="body">
          </p-selectButton>
      </ng-template>
    </p-toolbar>

    <div [hidden]="tablePlotSelected() !== 'table'" class="flex-1 min-h-0">
      <app-units-grid-input
        [tableTitle]="'Additional Doglegs'"
        [rows]="dlsOverrideRows"
        [columns]="dlsOverrideColumns"
        [userUnits]="userUnits()"
        [autoHeight]="true"
        [allowDeleteRows]="true"
        [minRows]="1"
        [createRow]="createDlsOverrideRow"
        [commitMode]="'debounced'"
        [commitDebounceMs]="300"
        (cellEdited)="onDlsOverrideGridChange()"
        (commitRequested)="onDlsOverrideGridChange()"
        (rowDeleted)="onDlsOverrideRowDeleted($event)"
        (rowsReset)="onDlsOverrideRowsReset()"
        (pasteApplied)="onDlsOverrideGridChange()"
      />
    </div>

    @if (tablePlotSelected() === 'plot') {
    <div class="flex flex-1 min-h-0">
      <app-xy-line-plot [plotData]="plotSeries()"
        [xAxisTitle]="xAxisTitle" [yAxisTitle]="yAxisTitle" [plotName]="plotName"
        [downloadPlotName]="downloadPlotName" [plotTitle]="'Additional Doglegs'"
        [xyLinePlotStore]="dlsOverridesStore"
      ></app-xy-line-plot>
    </div>
    }
  </div>
</app-tool-loader>